import * as React from "react";
import { useGiftcardBalance } from "../providers";

export const ViewBalance: React.FunctionComponent = (props) => {
  const { balanceDetails, onCheckAnother } = useGiftcardBalance();
  const balanceText = React.useMemo(() => {
    let balanceFloat = balanceDetails?.current_balance || 0;
    return `Your gift card balance is $${balanceFloat.toFixed(2)}`;
  }, [balanceDetails]);
  return (
    <React.Fragment>
      <div className="view-balance">
        <div className="balance-container">
          <p className="balance">{balanceText}</p>
        </div>
        <button className="check-another" onClick={onCheckAnother}>
          Check Another Card
        </button>
      </div>
    </React.Fragment>
  );
};
